import React from 'react';
import { View, useWindowDimensions, StyleSheet } from 'react-native';
import { isRightSideGapNeed, getCurrentBreakpoint } from './utils';
import GridItem from './GridItem';
import styles from './style';

function GridLayout({ data, gap = 10, renderItem }) {
  const { width: screenWidth } = useWindowDimensions();
  const currentBreakpoint = getCurrentBreakpoint(screenWidth);

  return (
    <View style={styles.grid}>
      {data.map((item, index) => {
        const width = item.breakpoints?.[currentBreakpoint] || '100%';
        const isRightGapNeeded = isRightSideGapNeed(data, index, currentBreakpoint);
        return (
          <GridItem
            key={index}
            item={item}
            index={index}
            gap={gap}
            isRightGapNeeded={isRightGapNeeded}
            isButtomGapNeeded={true}
            width={width}
            renderItem={renderItem}
          />
        );
      })}
    </View>
  );
}

export default GridLayout;
